import { render, staticRenderFns } from "./bookdyinfo.vue?vue&type=template&id=3972745f&scoped=true"
import script from "./bookdyinfo.vue?vue&type=script&lang=js"
export * from "./bookdyinfo.vue?vue&type=script&lang=js"
import style0 from "./bookdyinfo.vue?vue&type=style&index=0&id=3972745f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972745f",
  null
  
)

export default component.exports